// @autogensync
import { Logger } from '@epihub/core/src/logger';
import { packageConst } from '@epihub/core/src/_ctx/package';

export const log = new Logger({
  packageConst,
});
